<template>
  <div class="fccSirs">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :orderby="sortBy"
            :actions="actions"
            addFilter
            :items="listagemSituacaoSir"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            :titlePage="titlePage"
            :titlePDF="titlePDF"
          ></fccTable>
        </div>
      </div>
      <fccModal
        centered
        idModal="addFieldModal"
        size="lg"
        :titleModal="titleModal"
        escondeFooter
        travaEsc
        travaBack
      >
        <form
          autocomplete="off"
          @submit.prevent="situacao.id === 0 ? adicionarSituacaoSir() : editarSituacaoSir()"
        >
          <div class="row innerPage">
            <div class="col-sm-12">
              <fccInput extraClasses="inputLabel" required v-model="situacao.descricao"
                >Situação</fccInput
              >
            </div>
          </div>

          <div class="row innerPage">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">{{
                labelsSystem.salvar
              }}</fccButton>
            </div>
          </div>
        </form>
      </fccModal>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import Sirs from './mixim/sirs'
Vue.mixin(Sirs)

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Situação SIR',
      titlePDF: 'Lista de Tipo de apresentação',
      titleModal: '',
      fields: [
        { key: 'id', label: 'Id', sortable: false },
        { key: 'descricao', label: 'Situação', sortable: true },
        { key: 'actions', label: '' }
      ],
      itemPorPage: '100',
      situacao: {},
      actions: [
        {
          button: true,
          funcaoButton: 'editSituacaoSir',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteSituacaoSir',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },
  methods: {
    deleteSituacaoSir: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.descricao).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlSir2 + 'SituacaoSir2Monit/Excluir/id?id=' + item.id,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listarSituacaoSir()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    addField() {
      this.situacao = {}
      this.situacao.id = 0
      this.titleModal = 'Adicionar Situação SIR'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    editarSituacaoSir() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlSir2 + 'SituacaoSir2Monit/Alterar',
          this.situacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarSituacaoSir()
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    adicionarSituacaoSir() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlSir2 + 'SituacaoSir2Monit/Adicionar',
          this.situacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarSituacaoSir()
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.adicionado, 'success')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    editSituacaoSir: function (_, item) {
      this.situacao = { ...item }
      this.titleModal = 'Editar Situação SIR'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    }
  },
  mounted: function () {
    this.listarSituacaoSir()
  }
}
</script>
